module.exports = __webpack_public_path__ + "img/innovations_medium@2x.bad3ae16.jpg";